import './Login.css';
import { useState, useEffect, useContext, createContext, useRef } from 'react';
import { LanguageContext } from './App';

function Login({isRegistrationActive,
	setRegistrationActive,
	isPhoneConfirmActive,
	setPhoneConfirmActive,
}) {
    const { language, setLanguage } = useContext(LanguageContext);

    const handleRegistration = () => {
        setRegistrationActive(!isRegistrationActive);
    };

    const handlePhoneConfirm = () => {
        setPhoneConfirmActive(!isPhoneConfirmActive);
    };

    return (
    	<div className='login-main-container' >
    		<img src='/images/logo-blue.png' className='login-form-logo' />
    {!isPhoneConfirmActive && (
  				<>
    		<div className='login-form'>
    			<h1>{isRegistrationActive ? 'Регистрация' : 'Вход'}</h1>
    			{isRegistrationActive && (
  				<>
   				<input placeholder='Имя' />
    			<input placeholder='Фамилия' />
    			<input placeholder='Город' />
    			<input placeholder='Адрес' />
  				</>
				)}
    			<input placeholder='Номер телефона' />
    			<input placeholder='Пароль' />
    			{isRegistrationActive && (
    			<input placeholder='Подтвердите пароль' />
    			)}
    			<button onClick={handlePhoneConfirm}>{isRegistrationActive ? 'Зарегистрироваться' : 'Войти'}</button>
    			<p onClick={handleRegistration}>{isRegistrationActive ? 'Уже зарегистрированы? Нажмите сюда' : 'Еще не зарегистрированы? Нажмите сюда'}</p>
    		</div>
    		    		</>
				)}
{isPhoneConfirmActive && (
  				<>
    		<div className='login-form'>
    			<h1>Введите код</h1>
    			<p className='login-form-description'>Мы отправили на указанный номер телефона СМС с кодом подтверждения, введите его сюда</p>
    			<input placeholder='Код' />
    			<button>Подтвердить</button>
    		</div>
    		</>
				)}
    	</div>
    );
}

export default Login;